import { bool, func } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrButton3, { ButtonIcon, ButtonText } from "UI/FnrButton3";

DeleteConfirmation.propTypes = {
  onDelete: func,
  onCancel: func,
  isDeleting: bool,
  isArchiving: bool,
};

export default function DeleteConfirmation({ onDelete, onCancel, isDeleting }) {
  return (
    <>
      <P>Are you sure you want to delete this report?</P>
      <SpaceBetween>
        <FnrButton3
          onClick={onDelete}
          color="red"
          loading={isDeleting}
          disabled={isDeleting}
        >
          <ButtonIcon fas fa-trash-alt />
          <ButtonText>Delete</ButtonText>
        </FnrButton3>
        <FnrButton3 onClick={onCancel} color="gray" disabled={isDeleting}>
          <ButtonText>Cancel</ButtonText>
        </FnrButton3>
      </SpaceBetween>
    </>
  );
}

const P = styled.p`
  margin: 0;
`;

const SpaceBetween = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;
